import { Slot } from '@radix-ui/react-slot'
import clsx from 'clsx'
import { type ReactNode } from 'react'

type Props = {
  title: string | ReactNode
  titleAsChild?: boolean
  trailingTitle?: ReactNode
  description: ReactNode
  breadcrumb?: ReactNode
  titleSize?: 'lg' | 'xl'
}

export default function QuoteFlowHeader ({ title, titleAsChild, description, trailingTitle, breadcrumb, titleSize = 'lg' }: Props) {
  const TitleComponent = titleAsChild ? Slot : 'h1'

  return (
    <div className='flex flex-col gap-y-2 mb-6 md:mb-10'>
      {breadcrumb && (
        <div className='mb-2'>
          {breadcrumb}
        </div>
      )}
      <div className='flex items-center justify-between gap-x-2'>
        <TitleComponent className={clsx(
          'text-gray-800',
          {
            'heading-sm': titleSize === 'lg',
            'heading-lg md:heading-xl': titleSize === 'xl'
          })}
        >
          {title}
        </TitleComponent>
        {trailingTitle}
      </div>
      <div className='body text-gray-500'>
        {description}
      </div>
    </div>
  )
}
